import { LogoSquare } from "@assets/assets";
import { Box } from "@mui/material";

const LogoSquareIcon = (props: any): JSX.Element => {
  return <Box component="img" alt="chart" src={LogoSquare} {...props} />;
};

export default LogoSquareIcon;
